import axios from 'axios'



// export const baseUrl = `https://apipv.farmaonline.com/sellerpostventawc`
export const baseUrl = `https://apipv.farmaonline.com/sellerpostventawc`
export const cargarFotosUrl = `https://apipv.farmaonline.com/sellerpostventawc/cargarFotos`
export const FILES_PATH  = `https://apipv.farmaonline.com/appfiles`


// export const imgUrl = ``
export const HTTP = axios.create({ 
    baseURL: baseUrl,
    headers: {
        'Content-Type' : 'application/json',
        'x-api-key' : '929bb0364ce14375a5f78257f36c44f9'
        // 'Authorization': `Bearer ${window.sessionStorage.getItem('token')}`,
        // 'Accept': 'application/json',
        // 'Content-Type': 'application/json',
        // 'Content-Type': 'multipart/form-data' ,
        // 'Content-Type': 'application/x-www-form-urlencoded'

    },
    crossDomain: true
});
